import * as React from 'react';

/**
 * 入场动效：给容器加 data-reveal，进入视口后加 data-in，子元素按 --i 依次出现（样式见 styles.css）。
 * 用法：const ref = useReveal<HTMLDivElement>(); <div ref={ref} data-reveal>…</div>
 */
export function useReveal<T extends HTMLElement>() {
  const ref = React.useRef<T>(null);
  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    Array.from(el.children).forEach((c, i) => (c as HTMLElement).style.setProperty('--i', String(i)));
    if (typeof IntersectionObserver === 'undefined') {
      el.setAttribute('data-in', '');
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            el.setAttribute('data-in', '');
            io.disconnect();
          }
        }
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.01 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return ref;
}

/** 在 main.tsx 调用一次：之后 [data-reveal] 才会有隐藏的初始态。 */
export function enableReveal() {
  document.documentElement.classList.add('reveal-ready');
}
